import gql from 'graphql-tag';
import {hooks} from 'lib.front';
const {useApolloLazyQ} = hooks;

const queryMensajeLlave = gql`
   query enviarMensaje($receptores: [ReceptorMsgLlaveInput]) {
      enviarMensajeLlave(receptores: $receptores) {
         msg
      }
   }
`;

export default function useMensajeLlave({callbackProcesarData, callbackError, callbackLoading}) {
   return useApolloLazyQ(queryMensajeLlave, {
      callbackProcesarData,
      callbackError,
      callbackLoading
   });
}
